import { useState } from 'react';

export const useImageError = () => {
  const [imgExists, setImgExists] = useState(true);
  const handleError = () => {
    setImgExists(false);
  };

  return { imgExists, handleError };
};
